import { TechCardStatus, TechCardStatuses } from '@/shared';

export const MAP_STATUS_TO_NAME: Record<TechCardStatus, string> = {
	[TechCardStatuses.released]: 'Отгружена',
	[TechCardStatuses.progress]: 'В работе',
	[TechCardStatuses.accepted_at_sgd]: 'Принята на СГД',
	[TechCardStatuses.canceled]: 'Аннулирована',
	[TechCardStatuses.partially_issued]: 'Частично выдана',
	[TechCardStatuses.completed]: 'Завершена',
	[TechCardStatuses.accepted_at_storage]: 'На складе',
	[TechCardStatuses.wasted]: 'Забракована',
};

export const MAP_STATUS_TO_HEADER: Partial<
	Record<'assembly' | 'preform' | 'product' | 'rubber', Partial<Record<TechCardStatus, string>>>
> = {
	assembly: {
		[TechCardStatuses.progress]: 'Заполнение операции',
		[TechCardStatuses.accepted_at_sgd]: 'Выдача из СГД',
		[TechCardStatuses.partially_issued]: 'Выдача из СГД',
	},
	preform: {
		[TechCardStatuses.partially_issued]: 'Выдача со склада',
		[TechCardStatuses.accepted_at_storage]: 'Выдача со склада',
	},
	product: {
		[TechCardStatuses.progress]: 'Заполнение операции',
		[TechCardStatuses.accepted_at_sgd]: 'Выдача из СГД',
		[TechCardStatuses.partially_issued]: 'Выдача из СГД',
		[TechCardStatuses.accepted_at_storage]: 'Выдача со склада',
	},
	rubber: {
		[TechCardStatuses.progress]: 'Заполнение операции',
		[TechCardStatuses.accepted_at_sgd]: 'Выдача из СГД',
		[TechCardStatuses.partially_issued]: 'Выдача из СГД',
		[TechCardStatuses.accepted_at_storage]: 'Выдача со склада',
	},
};
